module.exports = __webpack_public_path__ + "img/ico_pencil.57d896dc.svg";